import { useState } from 'react'
import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/v2/ui'
import { CampaignCreatorModal } from './CampaignCreatorModal'
import type { AnalysisMode } from './AnalysisModeCards'

interface CampaignCreatorProps {
  initialMode?: AnalysisMode
}

export function CampaignCreator({ initialMode }: CampaignCreatorProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button
        variant="primary"
        onClick={() => setOpen(true)}
        className="campaign-creator-trigger"
        iconLeft={<Plus className="h-4 w-4" aria-hidden="true" />}
      >
        {t('campaignCreator.triggerBtn')}
      </Button>
      <CampaignCreatorModal open={open} onClose={() => setOpen(false)} initialMode={initialMode} />
    </>
  )
}
